import { LogoColored } from 'melp-design/icons';
import { SystemColors } from 'melp-design/style';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useAuthContext } from 'auth';
import { APP, ROUTES } from 'config';
import { useMe } from 'state/Administrators';
import { StorageKeys } from 'types/LocalStorage';
import { AccountSidebar } from './account-sidebar.component';
import { GlobalSearch } from './global-search.component';
import { NavMenu } from './nav-menu.component';

export const Header = () => {
  const { loggedIn } = useAuthContext();
  const { me, isHrAdmin, isMelpAdmin } = useMe();
  const { i18n } = useTranslation();
  const homePageURL = isMelpAdmin
    ? ROUTES.admin.clients.list
    : ROUTES.root.index;

  useEffect(() => {
    if (!me) return;

    const localLang = localStorage.getItem(StorageKeys.lang);
    const defaultLang =
      me.parentCompany?.settings.defaultLanguage.toLocaleLowerCase() ??
      me.language.toLocaleLowerCase() ??
      APP.locales.default;

    i18n.changeLanguage(localLang ?? defaultLang);
  }, [i18n, me]);

  return (
    <Box
      component="header"
      sx={{
        backgroundColor: SystemColors.white,
        borderBottom: `1px solid ${SystemColors.grey[90]}`,
      }}
    >
      <Box
        sx={{
          height: 64,
          width: '100%',
          maxWidth: APP.layout.container.maxWidth + 48,
          mx: 'auto',
          px: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <NavLink
          to={homePageURL}
          style={{ display: 'flex', flexShrink: 0, marginRight: 24 }}
        >
          <LogoColored style={{ height: 28, width: 'auto' }} />
        </NavLink>
        <NavMenu />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            ml: 'auto',
            flexShrink: 0,
          }}
        >
          {loggedIn && isHrAdmin ? <GlobalSearch /> : null}
          {loggedIn ? <AccountSidebar /> : null}
        </Box>
      </Box>
    </Box>
  );
};
